import { api } from './api';

export const noteService = {
    fetchNotesForEntity: async (entityType, entityId) => {
        try {
            const response = await api.get(`/notes/entity/${entityType}/${entityId}`);
            if (!Array.isArray(response.data)) {
                console.error('noteService: Expected array but got:', typeof response.data);
                return [];
            }
            return response.data;
        } catch (error) {
            console.error('noteService.fetchNotesForEntity error:', error);
            throw error;
        }
    },

    fetchNotesMentioningUser: async (userId) => {
        try {
            const response = await api.get(`/notes/mentions/${userId}`);
            if (!Array.isArray(response.data)) {
                console.error('noteService: Expected array but got:', typeof response.data);
                return [];
            }
            return response.data;
        } catch (error) {
            console.error('noteService.fetchNotesMentioningUser error:', error);
            throw error;
        }
    },

    createNote: async (noteData) => {
        try {
            const response = await api.post('/notes', noteData);
            if (!response.data) {
                console.error('noteService: No response from create note');
                throw new Error('Failed to create note');
            }
            return response.data;
        } catch (error) {
            console.error('noteService.createNote error:', error);
            throw error;
        }
    },

    updateNote: async (noteId, noteData) => {
        try {
            const response = await api.put(`/notes/${noteId}`, noteData);
            if (!response.data) {
                throw new Error('Failed to update note');
            }
            return response.data;
        } catch (error) {
            console.error('noteService.updateNote error:', error);
            throw error;
        }
    },

    deleteNote: async (noteId) => {
        try {
            const response = await api.delete(`/notes/${noteId}`);
            if (!response.data) {
                throw new Error('Failed to delete note');
            }
            return response.data;
        } catch (error) {
            console.error('noteService.deleteNote error:', error);
            throw error;
        }
    }
};